import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import {useQuery} from 'react-query'
import {PageTitle} from '../../../../_metronic/layout/core'
import {InputDefault, TableDefault} from '../../../components/ui'
import {getListSelfCares} from '../../../modules/services/self-care.service'
import {getBreadCrumbs} from '../breadcrumbs'

const CustomerStatePage = () => {
  const headFields = ['Cycle', 'Name', 'Numbers of Members']
  const bodyFields = [
    'attributes.cycle',
    'attributes.name',
    'attributes.ongoing_members.data.length',
  ]
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)

  const {data, isLoading} = useQuery(['getListSelfCares', search, page], async () =>
    getListSelfCares(search, page)
  )
  const datas = data?.data
  const pageCount = data?.meta?.pagination.pageCount

  const nextPage = () => {
    setPage(page + 1)
  }
  const prevPage = () => {
    setPage(page - 1)
  }

  useEffect(() => {
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  return (
    <>
      <div className='card mb-10'>
        <div className='card-body d-flex justify-content-between align-items-center py-8'>
          <div className='ms-6'>
            <p className='fw-bold fs-6 p-0 m-0'>Member State</p>
          </div>
          <div className='me-6 d-flex flex-column align-items-end gap-4'>
            <div className='d-flex flex-row gap-4'>
              <InputDefault placeholder='Search' left={<i className='bi bi-search' />} />
            </div>
          </div>
        </div>
        <TableDefault
          head={headFields}
          body={bodyFields}
          data={datas}
          href='member-management/customer-state'
          allPaginate={pageCount}
          page={page}
          setsPage={setPage}
          nextPage={nextPage}
          prevPage={prevPage}
          customBtnAction='Member List'
          isCustomBtnActionLink
        />
      </div>
    </>
  )
}

const CustomerStateWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={getBreadCrumbs('member-management/customer-state')}>
        {intl.formatMessage({id: 'MENU.CUSTOMER_STATE'})}
      </PageTitle>
      <CustomerStatePage />
    </>
  )
}

export default CustomerStateWrapper
